module.exports = __webpack_public_path__ + "media/elephant_dsrl.310156d6.mp4";